

    
    <app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>

    <p-table  styleClass="ui-table-cars"   
    
    [(selection)]="selectedSpeakers"   
    [columns]="cols" [value]="speakers"    #dt>
        <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix" style="text-align: left">
                <button type="button" pButton icon="pi pi-file-o" *ngIf="false" iconPos="left" label="CSV" (click)="dt.exportCSV()" style="margin-right: 0.5em;"></button>
                <button type="button" pButton icon="pi pi-file-excel" *ngIf="false"  iconPos="left" label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;" class="btn-def"></button>
                <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" *ngIf="false" label="PDF" (click)="exportPdf()" class="btn-def"></button>
           
                <button type="button" pButton icon="pi pi-file-pdf" 
                iconPos="left"  label="Create" (click)="prepareCreate()" class="btn-def"></button>
            
    
             
     
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendmail(46)" *ngIf="selectedSpeakers">  <mat-icon class="mat-18">email</mat-icon>Model  FR </button>
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendmail(47)" *ngIf="selectedSpeakers">  <mat-icon class="mat-18">email</mat-icon>Model  EN</button>
    
                
    
    
                <p-toggleButton [(ngModel)]="loadByOrder" *ngIf="false"  offLabel="ByCompany" onLabel="ByRate"  class="btn-def"
             (onChange)='loadAll()'
             [style]="{'width':'150px','margin-left':'10px'}"></p-toggleButton>  
    
    
    
                <div style="float: right;">   
     
    
 
    
    
    
                    <span *ngIf="dt.filteredValue"> {{dt.filteredValue.length}} / </span>{{dt.totalRecords}} Speaker
                    
                    <button type="button" *ngIf="false"  pButton icon="pi pi-file" iconPos="left" label="CSV - Selection Only" (click)="dt.exportCSV({selectionOnly:true})"  ></button>
               
                    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                </div>
         
            </div>
           
     
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
               
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
            </tr>
           
         
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input  pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
               
                  </th>
            </tr>
        </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr   [pSelectableRow]="rowData"
         [ngStyle]="{ 'color': rowData.dateImpression ? 'red' : ''}" style="height:34px">
         
     
         <!---->

         <td>
            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
        </td>
            <td *ngFor="let col of columns"  [ngSwitch]="col.field" pEditableColumn>
            <span *ngSwitchDefault>{{rowData[col.field]}}</span> 
            <span *ngSwitchCase="'entreprise'">
         <span (click)="gotoBadges(rowData.idClient)" [ngStyle]="{'color': rowData.uid ? 'green' : ''}" style=" text-decoration: underline;cursor: pointer;"> {{rowData.entreprise}}  </span>   
            </span>
    
                <p-cellEditor *ngSwitchCase="'note'">
                   
                    <ng-template pTemplate="input">
                        <textarea rows="10" cols="5" pInputTextarea    (keyup)='editNote(rowData)' (blur)='blur(rowData)' [(ngModel)]="rowData.note"></textarea>
                      
                    </ng-template>
                    <ng-template pTemplate="output">
                       {{rowData.note}}  {{rowData.dateImpression |  date}}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td>
                <button pButton type="button" class="ui-button-danger" (click)="confirm1(rowData)" icon="pi pi-trash"
                    style="margin-right: .5em"></button>
                <button pButton type="button" class="btn-def" (click)="visible=true;selectedSpeaker=rowData"
                    icon="pi pi-pencil"></button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" let-columns="columns">
        <tr style="height:34px">
            <td *ngFor="let col of columns">
                <div class="loading-text"></div>
            </td>
        </tr>
    </ng-template>
    </p-table>
   
 


   <p-dialog   [(visible)]="visible"  *ngIf="selectedSpeaker" [style]="{width: '700px', minWidth: '500px'  }"     >
    

 
    <mat-card style="padding: 100px;height:  500px ">
        <div class="row">
            
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Nom" [(ngModel)]="selectedSpeaker.nom"  >
                </mat-form-field>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Mobile" [(ngModel)]="selectedSpeaker.mobile" >
                </mat-form-field> 
            </div>
        </div>
        <div class="row">
            
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="E-Mail" [(ngModel)]="selectedSpeaker.mail"  type="mail">
                </mat-form-field>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field floatPlaceholder="always">
                    <input matInput placeholder="Position" [matAutocomplete]="autocompleteTemplateRefId" 
                        [(ngModel)]="selectedSpeaker.position"
                        (ngModelChange)="filterPositions(selectedSpeaker.position)">
                </mat-form-field>
        
                <mat-autocomplete   #autocompleteTemplateRefId="matAutocomplete">
                    <mat-option *ngFor="let position of positionsS" [value]="position">
                        {{position}}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
                 
        
               
        <div class="row">
            
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field floatPlaceholder="Pays">
                    <input matInput placeholder="Pays" [matAutocomplete]="autocompletePaysId"  
                     (ngModelChange)="filterPays(selectedSpeaker.pays)"  [(ngModel)]="selectedSpeaker.pays">
                  </mat-form-field>
        
                  <mat-autocomplete    #autocompletePaysId="matAutocomplete" >
                    <mat-option *ngFor="let pays of payss | async" [value]="pays.designationFr">
                      {{pays.designationFr}}
                    </mat-option>
                  </mat-autocomplete>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Panel" [(ngModel)]="selectedSpeaker.description" >
                </mat-form-field> 
            </div>
        
        </div>
              
        <div class="row">
            
           
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Company" [(ngModel)]="selectedSpeaker.entreprise" >
                </mat-form-field> 
            </div>
        
        </div>
        
                 
 
                 
        

          <button mat-button *ngIf="!selectedSpeaker.idSpeaker" (click)="create()">Ajouter</button>
          <button mat-button (click)="save()" *ngIf="selectedSpeaker.idSpeaker">Editer</button>
                </mat-card>


            </p-dialog> 